import React, { forwardRef }  from "react";
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.no";
import { Form, Col, InputGroup } from "react-bootstrap";
import PropTypes from "prop-types";
import { BfFormLabel, BfFormLabelSm, BfFormErrorSm, BfFormControl, BfSelect, BfFormCheck } from '../styledForm/styledBlueForm'
import DatePicker from "react-datepicker";
import { dateToString } from "../../util/date/dateRoutines";
import GebyrInfoToolTip from "../../containers/caseNew/debitorFormWithAI/GebyrInfoToolTip";
import CustomToolTip from "../../containers/caseNew/debitorFormWithAI/CustomToolTip";
import InfoToolTip from "../../containers/kredittvurdering/components/InfoToolTip";
import styled, { css } from "styled-components";


const StyledCleave = styled(Cleave)`
  width: 100%;
  padding: .375rem .75rem;
  height: calc(1.5em + .75rem + 2px);
  font-family: Fellix, sans-serif;
  font-size: 20px;
  background: #fff;
  border: 1px solid rgba(0,0,0,.28);
  border-radius: .5em;
  
  ${({ hasError }) =>
    hasError &&
    css`
      border: 2px solid #842029;
    `}
`;

const RadioLine = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 12px;
  row-gap: 6px;
  align-items: center;
  min-width: 0;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    align-items: start;
  }
`;

const GroupLabel = styled(BfFormLabel)`
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

const RadioChoices = styled.div`
  display: flex;
  gap: 8px;
  min-width: 0;
`;

const HelpRow = styled.div`
  grid-column: 1 / -1;
`;


export const BfColInput = (props) => {
    const {colspan, ...inputProps} = props
    return (
        <Col xs={12} md={colspan}>
            <FormInput {...inputProps}/>
            </Col>
    )
}


export const Picker = (props) => {

    //const [startDate, setStartDate] = useState(defaultDate());

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div 
            style={{ marginLeft: "7px", marginTop: "6px"}}    
            className="example-custom-input"
            onClick={onClick}
            ref={ref}>
            <span className="fa fa-calendar"/> 
        </div>
    ));

    const defaultDate = () => {

        if (props.value) {
            //const formatDate = d => `${d.substring(6, 10)}-${d.substring(3, 5)}-${d.substring(0, 2)}`
            let year = props.value.substring(6, 10)
            let mon = props.value.substring(3, 5)
            let day = props.value.substring(0, 2)

            return new Date(year, mon-1, day);
        }
        return new Date()
    }

    const dateChanged = (dateObj, evt) => {
       
        var newDate = dateToString(dateObj)

        let e = {
            target: {
                name: props.name,
                value: newDate,
            }
        }

        props.onChange(e)
    }

    return (
        <DatePicker
            selected={defaultDate()}
            onChange={dateChanged}
            customInput={<ExampleCustomInput />}
      />
    );
  };


export const FormInput = ({
    name,
    inputType,
    type = "text",
    formState,
    onChange,
    onBlur,
    error,
    children,
    messages,
    errorMessages,
    extraErrors,
    selectOptions,
    warning,
    belopWarning,
    fakturaTextWarning,
    fakturaText,
    showKredittvurderingInfo,
    kredittvurderingFieldsTitle,
    kredittvurderingFieldsText,
    ...props
}) => {

    const getPlaceHolder = () => {
        let result = ""
        if (!props.disabled) {
            result = messages[name + "Placeholder"]
        }
        return result
    }

    const showBorder = (fieldName) => {
        let allErrors = { ...errorMessages, ...extraErrors }
        let error = allErrors[fieldName]
        if (!error)
            return {}

        return { border: '2px solid #842029' }
    }

    const showCleaveBorder = (fieldName) => {
        let allErrors = { ...errorMessages, ...extraErrors }
        let error = allErrors[fieldName]
        if (!error)
            return {
                fontFamily: "Fellix, sans-serif",
                fontSize: '20px',
                border: "1px solid #dee2e6",
                height: "calc(1.5em + .75rem + 2px)",
                padding: ".375rem .75rem",
                borderRadius: "0.5em"
            }

        return {
            fontFamily: "Fellix, sans-serif",
            fontSize: '20px',
            height: "calc(1.5em + .75rem + 2px)",
            padding: ".375rem .75rem",
            borderRadius: "0.5em",
            border: '2px solid #842029'
        }
    }
    const hasError = !!((errorMessages?.[name]) || (extraErrors?.[name]));

    if (inputType === 'textarea') {
        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>{messages[name + "Label"]}</BfFormLabel>
                <Form.Control as="textarea" 
                    id={name}
                    name={name}
                 
                    rows={3}
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    style={showBorder(name)}
                    disabled={props.disabled}
                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }
    else if (inputType === 'fakturaText') {
        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>
                    {messages[name + "Label"]}
                    {warning && (
                        <GebyrInfoToolTip>
                            <i
                                className="fa fa-exclamation-triangle"
                                style={{ color: '#ff8c00', marginLeft: '8px' }}
                            />
                        </GebyrInfoToolTip>
                    )}
                    {fakturaTextWarning && (
                        <CustomToolTip caption={
                                <>
                                    KI har tolket dette som fakturatekst: <b>"{fakturaText}"</b>.
                                    <br />
                                    Fakturatekst kan maks inneholde 29 tegn og vi har dermed kuttet avlest verdi. 
                                </>
                            }>
                            <i
                                className="fa fa-info-circle"
                                style={{ color: '#044F67', marginLeft: '8px' }}
                            />

                        </CustomToolTip>
                    )}
                </BfFormLabel>
                <Form.Control
                    id={name}
                    name={name}
                    rows={3}
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={formState[name] || ''}
                    error={error}
                    style={showBorder(name)}
                    disabled={props.disabled}
                    autoComplete="off"
                    maxLength={props.maxLength}
                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }
    else if (inputType === 'select') {

        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>{messages[name + "Label"]}</BfFormLabel>
                <BfSelect
                    id={name}
                    as={inputType}
                    name={name}                                        
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    style={showBorder(name)}
                    disabled={props.disabled}                    
                >
                    {selectOptions()}
                </BfSelect>

                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }
     else if (inputType === 'radio') {
        return (
          <Form.Group>
            <BfFormLabel style={{display: 'flex'}} htmlFor={name}>
                {messages[name + "Label"]}
                {showKredittvurderingInfo && (
                    <InfoToolTip 
                        title={ kredittvurderingFieldsTitle } 
                        caption={ kredittvurderingFieldsText }
                    >
                        <i
                            className="fa fa-info-circle"
                            style={{ color: '#044F67', marginLeft: '8px' }}
                        />
                    </InfoToolTip>
                )}
            </BfFormLabel>
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '0.5rem' }}>
                {selectOptions.map((option) => (
                <BfFormCheck
                    key={option.value}
                    type="radio"
                    id={`${name}-${option.value}`}
                    name={name}
                    label={option.label}
                    value={option.value}
                    onChange={onChange}
                    checked={formState[name] === option.value}
                    disabled={props.disabled}
                />
                ))}
            </div>
            <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
            <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
          </Form.Group>
        );
    }
    else if (inputType === 'radioHorizontalLabel') {
        const labelId = `${name}-group-label`;

        return (
            <Form.Group>
            <RadioLine role="group" aria-labelledby={labelId}>
                <GroupLabel id={labelId}>
                {messages[name + "Label"]}
                {showKredittvurderingInfo && (
                    <InfoToolTip
                    title={kredittvurderingFieldsTitle}
                    caption={kredittvurderingFieldsText}
                    >
                    <i className="fa fa-info-circle" style={{ color: '#044F67' }} />
                    </InfoToolTip>
                )}
                </GroupLabel>

                <RadioChoices>
                {selectOptions.map((option) => (
                    <BfFormCheck
                    key={option.value}
                    type="radio"
                    id={`${name}-${option.value}`}
                    name={name}
                    label={option.label}
                    value={option.value}
                    onChange={onChange}
                    checked={formState[name] === option.value}
                    disabled={props.disabled}
                    className="form-check-inline"
                    />
                ))}
                </RadioChoices>

                <HelpRow>
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
                </HelpRow>
            </RadioLine>
            </Form.Group>
        );
    }
    else if (inputType === 'cleaveDate') {                

        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>{messages[name + "Label"]}</BfFormLabel><br />

                <InputGroup>
                    <Cleave                        
                        id={name}
                        name={name}
                        type={inputType}
                        className='form-control'
                        placeholder={getPlaceHolder()}
                        onChange={onChange}
                        value={(formState[name]) ? (formState[name]) : ''}
                        error={error}
                        style={showCleaveBorder(name)}
                        disabled={props.disabled}

                        options={{
                            date: true,
                            datePattern: ['d', 'm', 'Y'],
                            delimiter: '.'
                        }}
                        autoComplete="off"
                    
                    />
                    <Picker                        
                        id={'p'+ name}
                        name={name}
                        onChange={onChange}
                        formState={formState}
                        value={(formState[name]) ? (formState[name]) : ''}                
                    />    
                </InputGroup>             

                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;                
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }
    else if (inputType === 'cleavePhone') {

        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>{messages[name + "Label"]}</BfFormLabel><br />
                <Cleave
                    id={name}
                    name={name}
                    type={inputType}
                    className='form-control'
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    style={showCleaveBorder(name)}
                    disabled={props.disabled}
                    autoComplete="none"

                    options={{
                        phone: true,
                        phoneRegionCode: 'NO'
                    }}

                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }
    else if (inputType === 'cleaveAmount') {

        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>{messages[name + "Label"]}</BfFormLabel><br />
                <Cleave
                    id={name}
                    name={name}
                    type={inputType}
                    className='form-control'
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    style={showCleaveBorder(name)}
                    disabled={props.disabled}
                    autoComplete="off"

                    options={{
                        numeral: true,
                        numeralThousandsGroupStyle: 'thousand',
                        delimiter: ' ',
                        numeralDecimalMark: ','
                    }}

                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }
    else if (inputType === 'cleaveAmountPDF') {

        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>
                    {messages[name + "Label"]}
                    {belopWarning && (
                        <CustomToolTip caption="Sjekk at purregebyr ikke er inkludert i beløp før du sender inn.">
                            <i
                                className="fa fa-info-circle"
                                style={{ color: '#044F67', marginLeft: '8px' }}
                            />

                        </CustomToolTip>
                    )}
                </BfFormLabel>
                <Cleave
                    id={name}
                    name={name}
                    type={inputType}
                    className='form-control'
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    style={showCleaveBorder(name)}
                    disabled={props.disabled}
                    autocomplete="off"

                    options={{
                        numeral: true,
                        numeralThousandsGroupStyle: 'thousand',
                        delimiter: ' ',
                        numeralDecimalMark: ','
                    }}

                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }

    else if (inputType === 'cleaveOrgNr') {

        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>{messages[name + "Label"]}</BfFormLabel><br />
                <StyledCleave
                    id={name}
                    name={name}
                    type={inputType}
                    className='form-control'
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    disabled={props.disabled}
                    autoComplete="off"
                    hasError={hasError}

                    options={{
                        numericOnly: true,
                        blocks: [3, 3, 3],
                    }}

                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }

    else if (inputType === 'cleaveOrgNrNoLabel') {

        return (
            <Form.Group>
                <StyledCleave
                    id={name}
                    name={name}
                    type={inputType}
                    className='form-control'
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    disabled={props.disabled}
                    autoComplete="off"
                    hasError={hasError}

                    options={{
                        numericOnly: true,
                        blocks: [3, 3, 3],
                    }}

                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }

    else if (inputType === 'cleaveFnrNr') {

        return (
            <Form.Group>
                <BfFormLabel htmlFor={name}>{messages[name + "Label"]}</BfFormLabel><br />
                <StyledCleave
                    id={name}
                    name={name}
                    type={inputType}
                    className='form-control'
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    disabled={props.disabled}
                    autoComplete="off"
                    hasError={hasError}

                    options={{
                        numericOnly: true,
                        blocks: [6, 5],
                    }}

                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }

    else if (inputType === 'cleaveFnrNrNoLabel') {

        return (
            <Form.Group>
                <StyledCleave
                    id={name}
                    name={name}
                    type={inputType}
                    className='form-control'
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    disabled={props.disabled}
                    autoComplete="off"
                    hasError={hasError}

                    options={{
                        numericOnly: true,
                        blocks: [6, 5],
                    }}

                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }

    else if (inputType === 'cleaveOrgPersonNr') {

        return (
            <Form.Group>
                <BfFormLabel>{messages[name + 'Label']}</BfFormLabel><br />
                <Cleave
                    id={name}
                    name={name}
                    type={inputType}
                    className='form-control'
                    placeholder={getPlaceHolder()}
                    onChange={onChange}
                    value={(formState[name]) ? (formState[name]) : ''}
                    error={error}
                    style={showCleaveBorder(name)}
                    disabled={props.disabled}
                    autoComplete="off"
                    autoFocus={true}
                    options={{
                        numericOnly: true,
                        blocks: [11],
                    }}

                />
                <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
                <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>
            </Form.Group>
        )
    }

    return (
        <Form.Group>
            <BfFormLabel htmlFor={name}>{messages[name + "Label"]}</BfFormLabel>
            <BfFormControl
                id={name}
                name={name}
                type={inputType}
                placeholder={getPlaceHolder()}
                onChange={onChange}
                onBlur={onBlur}
                value={(formState[name]) ? (formState[name]) : ''}
                error={error}
                style={showBorder(name)}
                disabled={props.disabled}
                autoComplete="off"
                maxLength={props.maxLength}
            />
            <BfFormLabelSm>{messages[name + "Small"]}</BfFormLabelSm>&nbsp;
            <BfFormErrorSm>{errorMessages[name]}</BfFormErrorSm>            
        </Form.Group>
    );
};

FormInput.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    inputType: PropTypes.oneOf(["text", "number", "password", "select", "textarea", "cleaveDate", "cleavePhone", "cleaveAmount", "cleaveOrgNr", "cleaveOrgNrNoLabel", "cleaveFnrNr", "cleaveFnrNrNoLabel", "fakturaText", "cleaveAmountPDF", "radio", "radioHorizontalLabel"]),
    //value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired
};
